import React from 'react';

import './styles.css';

const TextMuted = ({ children }) => {
  return <span className="TextMuted">{children}</span>;
};

export default TextMuted;
